export var DataSourceEnum;
(function (DataSourceEnum) {
    DataSourceEnum["AssessmentPurpose"] = "Assessment Purpose";
    DataSourceEnum["Regency"] = "Regency";
    DataSourceEnum["Education"] = "Education";
    DataSourceEnum["Gender"] = "Gender";
})(DataSourceEnum || (DataSourceEnum = {}));
export var DataReferenceEnum;
(function (DataReferenceEnum) {
    DataReferenceEnum["PersonalDataNation"] = "PersonalData_Nation";
})(DataReferenceEnum || (DataReferenceEnum = {}));
